module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae.1d540bfbe578949443de95fd05a24193.png";